import React, { Component } from 'react';
class FormTitle extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingBottom: 10 }}>
                <div style={{ backgroundColor: '#BFBFBF', width: 2, height: 17, marginRight: 5 }}></div>
                <div style={{ color: '#1A1A1A', fontSize: 14 }}>{this.props.title}</div>
            </div>);
    }
}
export default FormTitle;
